import { parseAsNumberLiteral, useQueryState } from 'nuqs'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface MonthPaginatorProps {
  years: number[]
  allowAllMonths?: boolean
  className?: string
}

export const MonthPaginator = (props: MonthPaginatorProps) => {
  const { allowAllMonths = true, className } = props

  const currentYear = Number(new Date().getFullYear())
  const currentMonth = Number(new Date().getMonth())

  const [activeYear, setActiveYear] = useQueryState(
    'year',
    parseAsNumberLiteral(props.years).withDefault(currentYear),
  )

  const months = Array.from(
    { length: activeYear < currentYear ? 12 : currentMonth + 1 },
    (_, i) => i + 1,
  )

  let [activeMonth, setActiveMonth] = useQueryState(
    'month',
    parseAsNumberLiteral(months),
  )

  activeMonth = !allowAllMonths && activeMonth === null ? currentMonth + 1 : activeMonth

  return (
    <div className={cn("flex justify-between gap-2 overflow-x-auto", className)}>
      <div className="flex gap-1" aria-label="Kalendářní roky">
        {props.years.map((year) => (
          <Button
            key={year}
            variant={year === activeYear ? 'secondary' : 'outline'}
            className={year === activeYear ? 'bg-muted font-semibold' : ''}
            onClick={() => {
              setActiveYear(year)
              setActiveMonth(null)
            }}
          >
            {year}
          </Button>
        ))}
      </div>

      <div className="flex gap-1" aria-label="Měsíce vybraného roku">
        {allowAllMonths && (
          <Button
            key={null}
            variant={activeMonth === null ? 'secondary' : 'outline'}
            className={activeMonth === null ? 'bg-muted font-semibold' : ''}
            onClick={() => setActiveMonth(null)}
          >
            Vše
          </Button>
        )}
        {months.map((month) => (
          <Button
            key={month}
            variant={month === activeMonth ? 'secondary' : 'outline'}
            className={month === activeMonth ? 'bg-muted font-semibold' : ''}
            onClick={() => setActiveMonth(month)}
          >
            {month}
          </Button>
        ))}
      </div>
    </div>
  )
}
